module.exports = __webpack_public_path__ + "media/components/shared/static/close_search-e8286fe67a32a20e163feab67097a52c.svg";